// extracted by mini-css-extract-plugin
export default {"language":"ps1jc76SC_WQltHKk2kt"};